import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import locContext from "../context/locContext";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Slider from "react-slick";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

function Addtocard() {

  const date = new Date();
  const currentDate = date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  const userRoll = JSON.parse(localStorage.getItem("aerialst"));

  const id = userRoll.id;
  const user_phone = userRoll.phone;
  const user_name = userRoll.email;
  const user_email = userRoll.name;
  const [data, setData] = useState([]);
  const [coupon, setCoupon] = useState('')
  const [couponcode, setCouponCode] = useState({
    code: 'asd'
  })

  const [dataGst, setDataGst] = useState([]);
  const [product, setProduct] = useState([]);
  const [productex, setProductex] = useState([]);

  const [amount, setAmount] = useState({
    totalRupees: "",
    totalDoller: "",
    total_gstrupees: "",
    total_gstdoller: "",
  });

  const [gstamount, setGstamount] = useState({
    gstRupees: "",
    gstDoller: "",
  });
  const { location, getAddtoCartData } = useContext(locContext);
  const navigate = useNavigate();



  //        User Data
  const [user, setUser] = useState({});
  const getSubsriptionData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getStudentbyID/${id}`
      );

      if (res.status === 200) {
        setUser(res.data.data[0]);
      } else {
        setUser({});
      }
    } catch (err) {
      console.log(err);
    }
  };
  //        Invoice number
  const [invoice, setInvoice] = useState('')
  const getInvoiceData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getAllInvoice`
      );
      if (res.status === 200) {
        setInvoice(res.data.data.length + 1);
      } else {
        setInvoice([]);
      }
    } catch (err) {
      console.log(err);
    }
  };




  const [teams, setTeams] = useState(true)

  const [couponId, setCouponId] = useState('')

  const submitCoupon = async (e) => {
    try {
      if (!couponcode) {
        Swal.fire({
          title: "Please Enter Coupon Code",
          icon: "warning",
        });
      } else {
        const res = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/getCouponCodeByCode`, couponcode);
        console.log(res.data.data);

        if (res.status === 200) {
          if (res.data.data.length === 0) {
            Swal.fire({
              title: "Invalid Coupon Code",
              text: "Please check the code and try again.",
              icon: "warning",
              timer: 1500,
            });
          } else {
            getAddtoCartDataa();
            setCoupon(res.data.data[0].percent)
            setCouponId(res.data.data[0].id)
          }
        } else {
          // Unsuccessful request
          setCoupon('0')
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  //         add location
  const addLocationToDataGst = (dataGst) => {
    return dataGst.map(item => ({
      ...item,
      location: location,
    }));
  };
  const getAddtoCartDataa = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getAddToCart/${id}`
      );
      if (res.status === 200) {

        const fetchedData = res.data.data;

        const updatedData = fetchedData.map(item => {
          if (item.w_rupees !== null && item.w_doller !== null) {
            return {
              ...item,
              w_rupees: item.w_rupees * 1.18 * (1 - coupon / 100),
              w_doller: item.w_doller * 1.18 * (1 - coupon / 100),
              coupon_id: couponId,
            };
          } else if (item.doller !== null && item.rupees !== null) {
            return {
              ...item,
              doller: item.doller * 1.18 * (1 - coupon / 100),
              rupees: item.rupees * 1.18 * (1 - coupon / 100),
              coupon_id: couponId,
            };
          } else if (item.doller_pre !== null && item.rupees_pre !== null) {
            return {
              ...item,
              doller_pre: item.doller_pre * 1.18 * (1 - coupon / 100),
              rupees_pre: item.rupees_pre * 1.18 * (1 - coupon / 100),
              coupon_id: couponId,
            };
          } else if (item.amount !== null) {
            return {
              ...item,
              amount: item.amount * 1.18 * (1 - coupon / 100),
              amount_dol: item.amount_dol * 1.18 * (1 - coupon / 100),
              coupon_id: couponId,
            };
          } else {
            return item;
          }
        })
        // setDataGst(updatedData);
        setDataGst(addLocationToDataGst(updatedData));
        setData(res.data.data);

        const totalRupees = fetchedData.reduce(
          (sum, item) => sum + (item.rupees * (item.quantity || 1)) + (item.amount * item.quantity),
          0
        );
        const totalDoller = fetchedData.reduce(
          (sum, item) => sum + item.doller + (item.amount_dol * item.quantity),
          0
        );

        const totalWorkRu = fetchedData.reduce(
          (sum, item) => sum + item.w_rupees,
          0
        )
        const totalWorkDol = fetchedData.reduce(
          (sum, item) => sum + item.w_doller,
          0
        )
        //      Prerecorded
        const totalPreRu = fetchedData.reduce(
          (sum, item) => sum + item.rupees_pre,
          0
        )
        const totalPreDol = fetchedData.reduce(
          (sum, item) => sum + item.doller_pre,
          0
        )

        // const gstru = (totalRupees * 18) / 100;
        // const gstdo = (totalDoller * 18) / 100;
        // const gstWoru = (totalWorkRu * 18) / 100;
        // const gstWodol = (totalWorkDol * 18) / 100;
        // const gstPreru = (totalPreRu * 18) / 100;
        // const gstPredol = (totalPreDol * 18) / 100;


        const getamountrup = totalRupees + totalWorkRu + totalPreRu;
        const getamountdol = totalDoller + totalWorkDol + totalPreDol;
        // setAmount({
        //   totalRupees: (totalRupees + totalWorkRu).toFixed(2) * (1 - coupon / 100),
        //   totalDoller: (totalDoller + totalWorkDol).toFixed(2) * (1 - coupon / 100),
        //   total_gstrupees: getamountrup.toFixed(2) * (1 - coupon / 100),
        //   total_gstdoller: getamountdol.toFixed(2) * (1 - coupon / 100),
        // });
        setAmount({
          totalRupees: Math.round((totalRupees + totalWorkRu + totalPreRu) * (1 - coupon / 100)),
          totalDoller: Math.round((totalDoller + totalWorkDol + totalPreDol) * (1 - coupon / 100)),
          total_gstrupees: Math.round(getamountrup * (1 - coupon / 100)), // Rounds to the nearest integer
          total_gstdoller: Math.round(getamountdol * (1 - coupon / 100)), // Rounds to the nearest integer
        });
        // setGstamount({
        //   gstRupees: Math.round((gstru + gstWoru + gstPreru) * (1 - coupon / 100)),
        //   gstDoller: Math.round((gstdo + gstWodol + gstPredol) * (1 - coupon / 100)),
        // });
      } else {
        setData([]);
        setAmount("");
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getAddtoCartDataa();
  }, [coupon]);

  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You want to remove this item",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#5000C0",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const res = await axios.delete(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/deleteAddToCart/` + id
        );
        if (res.status === 200) {
          getAddtoCartDataa();
          getAddtoCartData();
        } else {
          Swal.fire({
            title: "Deleted failed!",
            text: "This item remove failed.",
            icon: "error",
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const headleSubmit = async (e, payment_stat, payment_type) => {
    try {
      if (data > 0) {
        Swal.fire({
          title: "No data available",
          icon: "warning",
        });
        return;
      }

      // Generate the PDF
      const content = contentRef.current;
      const canvas = await html2canvas(content, { scale: 1.5 });
      const imageData = canvas.toDataURL("image/jpeg", 0.8);
      const pdf = new jsPDF("portrait", "pt", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imageData, "JPEG", 0, 0, pdfWidth, pdfHeight, undefined, "FAST");

      // Convert PDF to Blob
      const pdfBlob = pdf.output("blob");

      // Prepare FormData
      const formData = new FormData();
      formData.append("pdf", pdfBlob, `invoice${invoice}.pdf`);
      formData.append("dataGst", JSON.stringify(data)); // Convert dataGst to JSON string

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/createOrderItem/?payment_stat=${payment_stat}&payment_type=${payment_type}`,
        formData
      );
      if (res.status === 200 && res.data.data) {
        getAddtoCartData();
        Swal.fire({
          icon: "success",
          title: "Your order has been placed successfully",
          timer: 1500,
        }).then(() => {
          navigate("/orderlist");
        });
      } else {
        // Unsuccessful request
        Swal.fire({
          title: "Buy failed",
          icon: "error",
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleimg = (e) => {
    e.target.src = "/assets/img/Aerial_Belly_Final_Logo.png";
    e.target.alt = "Image not found";
  };

  //              Razorpay
  const loadRazorpayScript = () => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  };
  const initiatePayment = async () => {
    if (!data[0].de_address) {
      const result = await Swal.fire({
        title: "Delivery Address Required",
        text: "You need to provide a delivery address to proceed with this purchase. If you are buying dance classes, you can skip this step.",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#5000C0",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Proceed to Payment",
        cancelButtonText: "Add Address"
      });
      if (result.isConfirmed) {
        const order = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/create-order`, { amount: amount.total_gstrupees });

        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,  // Replace with your Razorpay Key ID
          amount: order.data.amount,
          currency: "INR",
          name: "AeialBelly",
          description: "Transaction",
          order_id: order.data.id,
          handler: async function (response) {
            const datapy = {
              order_id: order.data.id,
              payment_id: response.razorpay_payment_id,
              signature: response.razorpay_signature,
              receiptNumber: order.data.receipt,
              user_id: id,
              amount: amount.total_gstrupees,
              status: "success"
            };
            const result = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/verify-payment`, datapy);
            if (result.status === 200) {
              headleSubmit(null, 1, 'Razorpay')
            } else {
              alert("Payment failed");
            }
          },
          prefill: {
            name: user_name,
            email: user_email,
            contact: user_phone
          }
        };
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      }
      // Swal.fire({
      //   title: "Please Enter Delivery Address",
      //   icon: "warning",
      // });
    } else {
      const order = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/create-order`, { amount: amount.total_gstrupees });

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,  // Replace with your Razorpay Key ID
        amount: order.data.amount,
        currency: "INR",
        name: "AeialBelly",
        description: "Transaction",
        order_id: order.data.id,
        handler: async function (response) {
          const datapy = {
            order_id: order.data.id,
            payment_id: response.razorpay_payment_id,
            signature: response.razorpay_signature,
            receiptNumber: order.data.receipt,
            user_id: id,
            amount: amount.total_gstrupees,
            status: "success"
          };
          const result = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/verify-payment`, datapy);
          if (result.status === 200) {
            headleSubmit(null, 1, 'Razorpay')
          } else {
            alert("Payment failed");
          }
        },
        prefill: {
          name: userRoll.name,
          email: userRoll.email,
          contact: userRoll.phone
        }
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    }
  };

  // Cash payment
  const cashPayment = async () => {
    const result = await Swal.fire({
      title: "Cash Payment",
      text: "Please ensure that your payment is made at least two days before the batch or event starts. Your admission will be confirmed only after the payment is successfully received.",
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel"
    })
    if (result.isConfirmed) {
      headleSubmit(null, 0, 'Cash')
    }
  }

  // 
  const getProductData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getallproduct`
      );
      if (res.status === 200) {
        setProduct(res.data.data);
      } else {
        setProduct([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getProductDataEx = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/getAllProductExtra`
      );
      if (res.status === 200) {
        setProductex(res.data.data);
      } else {
        setProductex([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    loadRazorpayScript();
    getProductData();
    getProductDataEx();
    getSubsriptionData();
    getInvoiceData();
  }, []);

  //             PayPal
  const [error, setError] = useState(null);
  const initialOptions = {
    "client-id": process.env.REACT_APP_PAYPAL_KEY_ID,
    currency: "USD",
    intent: "capture",
  };

  const handleOptionChange = (e) => {
    const { checked } = e.target
    if (checked) {
      setTeams(false)
    } else {
      setTeams(true)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCouponCode({
      ...couponcode,
      [name]: value,
    });
  };

  const [cart, setCart] = useState({
    "user_id": id,
    "cart_type": 1,
    "quantity": 1
  });

  const addGroupcart = async (id) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/addToCart/${id}`, cart);
      if (res.status === 200 && res.data.data) {
        Swal.fire({
          icon: "success",
          title: "This Add to cart",
          timer: 1500,
        })
        getAddtoCartDataa();
      } else if (res.status === 201) {
        Swal.fire({
          icon: "warning",
          title: res.data.msg,
          confirmButtonText: "OK",
          confirmButtonColor: "#06bdff",
        });
      }
    } catch (err) {
      console.error(err);
    }

  }

  const quantityChange = (e, id, type, quantity) => {
    const newQuantity = type === 1 ? quantity + 1 : quantity - 1;
    // setQuantityCh({
    //   id: id,
    //   quantity: newQuantity
    // });
    UpdateCart({ id, quantity: newQuantity });
  };

  const UpdateCart = async (updatedQuantity) => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_BACKEND_BASE_URL}/editCart`, updatedQuantity);
      if (res.status === 200 && res.data.data) {
        getAddtoCartDataa();
      }
    } catch (err) {
      console.error(err);
    }
  };

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2500,
    prevArrow: false, // Use custom previous arrow
    nextArrow: false,
    responsive: [
      {
        breakpoint: 768, // For devices with width <= 768px
        settings: {
          slidesToShow: 2, // Show 2 slides
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For devices with width <= 480px
        settings: {
          slidesToShow: 2, // Show 1 slide
          slidesToScroll: 1,
        },
      },
    ],
  };

  //        PDF
  const contentRef = useRef(null);

  return (
    <>
      <div className="th-cart-wrapper space-top space-extra-bottom" style={{ background: 'white' }}>
        <div className="container">
          <nav
            aria-label="breadcrumb"
            style={{ "--bs-breadcrumb-divider": "none" }}
          >
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                  to="/"
                >
                  Home
                </Link>
                /
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                My Cart
              </li>
            </ol>
          </nav>

          {data.length === 0
            ? <div style={{ textAlign: 'center' }}>
              <svg data-name="Layer 1" width="35%" height="35%" viewBox="0 0 896 747.97143"><title>empty_cart</title><path d="M193.634,788.75225c12.42842,23.049,38.806,32.9435,38.806,32.9435s6.22712-27.47543-6.2013-50.52448-38.806-32.9435-38.806-32.9435S181.20559,765.7032,193.634,788.75225Z" transform="translate(-152 -76.01429)" fill="#2f2e41" /><path d="M202.17653,781.16927c22.43841,13.49969,31.08016,40.3138,31.08016,40.3138s-27.73812,4.92679-50.17653-8.57291S152,772.59636,152,772.59636,179.73811,767.66958,202.17653,781.16927Z" transform="translate(-152 -76.01429)" fill="#bd934c" /><rect x="413.2485" y="35.90779" width="140" height="2" fill="#f2f2f2" /><rect x="513.2485" y="37.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="452.2485" y="37.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="484.2485" y="131.90779" width="140" height="2" fill="#f2f2f2" /><rect x="522.2485" y="113.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="583.2485" y="113.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="670.2485" y="176.90779" width="140" height="2" fill="#f2f2f2" /><rect x="708.2485" y="158.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="769.2485" y="158.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="656.2485" y="640.90779" width="140" height="2" fill="#f2f2f2" /><rect x="694.2485" y="622.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="755.2485" y="622.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="417.2485" y="319.90779" width="140" height="2" fill="#f2f2f2" /><rect x="455.2485" y="301.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="516.2485" y="301.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="461.2485" y="560.90779" width="140" height="2" fill="#f2f2f2" /><rect x="499.2485" y="542.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="560.2485" y="542.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="685.2485" y="487.90779" width="140" height="2" fill="#f2f2f2" /><rect x="723.2485" y="469.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="784.2485" y="469.90779" width="2" height="18.5" fill="#f2f2f2" /><polygon points="362.06 702.184 125.274 702.184 125.274 700.481 360.356 700.481 360.356 617.861 145.18 617.861 134.727 596.084 136.263 595.347 146.252 616.157 362.06 616.157 362.06 702.184" fill="#2f2e41" /><circle cx="156.78851" cy="726.03301" r="17.88673" fill="#3f3d56" /><circle cx="333.10053" cy="726.03301" r="17.88673" fill="#3f3d56" /><circle cx="540.92726" cy="346.153" r="11.07274" fill="#3f3d56" /><path d="M539.38538,665.76747H273.23673L215.64844,477.531H598.69256l-.34852,1.10753Zm-264.8885-1.7035H538.136l58.23417-184.82951H217.95082Z" transform="translate(-152 -76.01429)" fill="#2f2e41" /><polygon points="366.61 579.958 132.842 579.958 82.26 413.015 418.701 413.015 418.395 413.998 366.61 579.958" fill="#f2f2f2" /><polygon points="451.465 384.7 449.818 384.263 461.059 341.894 526.448 341.894 526.448 343.598 462.37 343.598 451.465 384.7" fill="#2f2e41" /><rect x="82.2584" y="458.58385" width="345.2931" height="1.7035" fill="#2f2e41" /><rect x="101.45894" y="521.34377" width="306.31852" height="1.7035" fill="#2f2e41" /><rect x="254.31376" y="402.36843" width="1.7035" height="186.53301" fill="#2f2e41" /><rect x="385.55745" y="570.79732" width="186.92877" height="1.70379" transform="translate(-274.73922 936.23495) rotate(-86.24919)" fill="#2f2e41" /><rect x="334.45728" y="478.18483" width="1.70379" height="186.92877" transform="translate(-188.46866 -52.99638) rotate(-3.729)" fill="#2f2e41" /><rect y="745" width="896" height="2" fill="#2f2e41" /><path d="M747.41068,137.89028s14.61842,41.60627,5.62246,48.00724S783.39448,244.573,783.39448,244.573l47.22874-12.80193-25.86336-43.73993s-3.37348-43.73992-3.37348-50.14089S747.41068,137.89028,747.41068,137.89028Z" transform="translate(-152 -76.01429)" fill="#a0616a" /><path d="M747.41068,137.89028s14.61842,41.60627,5.62246,48.00724S783.39448,244.573,783.39448,244.573l47.22874-12.80193-25.86336-43.73993s-3.37348-43.73992-3.37348-50.14089S747.41068,137.89028,747.41068,137.89028Z" transform="translate(-152 -76.01429)" opacity="0.1" /><path d="M722.87364,434.46832s-4.26731,53.34138,0,81.07889,10.66828,104.5491,10.66828,104.5491,0,145.08854,23.4702,147.22219,40.53945,4.26731,42.6731-4.26731-10.66827-12.80193-4.26731-17.06924,8.53462-19.20289,0-36.27213,0-189.8953,0-189.8953l40.53945,108.81641s4.26731,89.61351,8.53462,102.41544-4.26731,36.27213,10.66827,38.40579,32.00483-10.66828,40.53945-14.93559-12.80193-4.26731-8.53462-6.401,17.06924-8.53462,12.80193-10.66828-8.53462-104.54909-8.53462-104.54909S879.69728,414.1986,864.7617,405.664s-24.537,6.16576-24.537,6.16576Z" transform="translate(-152 -76.01429)" fill="#2f2e41" /><path d="M761.27943,758.78388v17.06924s-19.20289,46.39942,0,46.39942,34.13848,4.8083,34.13848-1.59266V763.05119Z" transform="translate(-152 -76.01429)" fill="#2f2e41" /><path d="M887.16508,758.75358v17.06924s19.20289,46.39941,0,46.39941-34.13848,4.80831-34.13848-1.59266V763.02089Z" transform="translate(-152 -76.01429)" fill="#2f2e41" /><circle cx="625.28185" cy="54.4082" r="38.40579" fill="#a0616a" /><path d="M765.54674,201.89993s10.66828,32.00482,27.73752,25.60386l17.06924-6.401L840.22467,425.9337s-23.47021,34.13848-57.60869,12.80193S765.54674,201.89993,765.54674,201.89993Z" transform="translate(-152 -76.01429)" fill="#bd934c" /><path d="M795.41791,195.499l9.60145-20.26972s56.54186,26.67069,65.07648,35.20531,8.53462,21.33655,8.53462,21.33655l-14.93559,53.34137s4.26731,117.351,4.26731,121.61834,14.93559,27.73751,4.26731,19.20289-12.80193-17.06924-21.33655-4.26731-27.73751,27.73752-27.73751,27.73752Z" transform="translate(-152 -76.01429)" fill="#3f3d56" /><path d="M870.09584,349.12212l-6.401,59.74234s-38.40579,34.13848-29.87117,36.27214,12.80193-6.401,12.80193-6.401,14.93559,14.93559,23.47021,6.401S899.967,355.52309,899.967,355.52309Z" transform="translate(-152 -76.01429)" fill="#a0616a" /><path d="M778.1,76.14416c-8.51412-.30437-17.62549-.45493-24.80406,4.13321a36.31263,36.31263,0,0,0-8.5723,8.39153c-6.99153,8.83846-13.03253,19.95926-10.43553,30.92537l3.01633-1.1764a19.75086,19.75086,0,0,1-1.90515,8.46261c.42475-1.2351,1.84722.76151,1.4664,2.01085L733.543,139.792c5.46207-2.00239,12.25661,2.05189,13.08819,7.80969.37974-12.66123,1.6932-27.17965,11.964-34.59331,5.17951-3.73868,11.73465-4.88,18.04162-5.8935,5.81832-.935,11.91781-1.82659,17.49077.08886s10.31871,7.615,9.0553,13.37093c2.56964-.88518,5.44356.90566,6.71347,3.30856s1.33662,5.2375,1.37484,7.95506c2.73911,1.93583,5.85632-1.9082,6.97263-5.07112,2.62033-7.42434,4.94941-15.32739,3.53783-23.073s-7.72325-15.14773-15.59638-15.174a5.46676,5.46676,0,0,0,1.42176-3.84874l-6.48928-.5483a7.1723,7.1723,0,0,0,4.28575-2.25954C802.7981,84.73052,782.31323,76.29477,778.1,76.14416Z" transform="translate(-152 -76.01429)" fill="#2f2e41" /><path d="M776.215,189.098s-17.36929-17.02085-23.62023-15.97822S737.80923,189.098,737.80923,189.098s-51.20772,17.06924-49.07407,34.13848S714.339,323.51826,714.339,323.51826s19.2029,100.28179,2.13366,110.95006,81.07889,38.40579,83.21254,25.60386,6.401-140.82123,0-160.02412S776.215,189.098,776.215,189.098Z" transform="translate(-152 -76.01429)" fill="#3f3d56" /><path d="M850.89294,223.23648h26.38265S895.6997,304.31537,897.83335,312.85s6.401,49.07406,4.26731,49.07406-44.80675-8.53462-44.80675-2.13365Z" transform="translate(-152 -76.01429)" fill="#3f3d56" /><path d="M850,424.01429H749c-9.85608-45.34-10.67957-89.14649,0-131H850C833.70081,334.115,832.68225,377.62137,850,424.01429Z" transform="translate(-152 -76.01429)" fill="#f2f2f2" /><path d="M707.93806,368.325,737.80923,381.127s57.60868,8.53462,57.60868-14.93559-57.60868-10.66827-57.60868-10.66827L718.60505,349.383Z" transform="translate(-152 -76.01429)" fill="#a0616a" /><path d="M714.339,210.43455l-25.60386,6.401L669.53227,329.91923s-6.401,29.87117,4.26731,32.00482S714.339,381.127,714.339,381.127s4.26731-32.00483,12.80193-32.00483L705.8044,332.05288,718.60633,257.375Z" transform="translate(-152 -76.01429)" fill="#3f3d56" /><rect x="60.2485" y="352.90779" width="140" height="2" fill="#f2f2f2" /><rect x="98.2485" y="334.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="159.2485" y="334.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="109.2485" y="56.90779" width="140" height="2" fill="#f2f2f2" /><rect x="209.2485" y="58.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="148.2485" y="58.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="250.2485" y="253.90779" width="140" height="2" fill="#f2f2f2" /><rect x="350.2485" y="255.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="289.2485" y="255.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="12.2485" y="252.90779" width="140" height="2" fill="#f2f2f2" /><rect x="112.2485" y="254.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="51.2485" y="254.40779" width="2" height="18.5" fill="#f2f2f2" /><rect x="180.2485" y="152.90779" width="140" height="2" fill="#f2f2f2" /><rect x="218.2485" y="134.90779" width="2" height="18.5" fill="#f2f2f2" /><rect x="279.2485" y="134.90779" width="2" height="18.5" fill="#f2f2f2" /></svg>
              <h6 className="mt-4">
                Your cart’s feeling a little lonely—time to fill it with
                something fabulous!
              </h6>
            </div>
            : <>
              <form className="woocommerce-cart-form mt-5">

                <table className="cart_table">
                  <thead>
                    <tr>
                      <th className="cart-col-image">Image</th>
                      <th className="cart-col-productname">Product Name</th>
                      <th className="cart-col-price">Level</th>
                      <th className="cart-col-total">Duration</th>
                      <th className="cart-col-quantity">Size</th>
                      <th className="cart-col-quantity">Color</th>
                      <th className="cart-col-quantity">Quantity</th>
                      <th className="cart-col-remove">Amount</th>
                      <th className="cart-col-remove"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length === 0 ? (
                      <tr>
                        <td colSpan="12">
                          Your cart’s feeling a little lonely—time to fill it with
                          something fabulous!
                        </td>
                      </tr>
                    ) : (
                      data.map((dataa, index) => {
                        return (
                          <tr className="cart_item" key={index}>
                            <td data-title="Image">
                              <div className="cart-productimage">
                                <img
                                  src={`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/${dataa.photo || dataa.w_photo || '/photo/' + dataa.photo_pre}`}
                                  width="91"
                                  height="91"
                                  style={{ objectFit: 'contain' }}
                                  draggable={false}
                                  onError={handleimg}
                                />
                              </div>
                            </td>
                            <td data-title="Product Name">
                              <div className="cart-productname">
                                {dataa.table_name || dataa.w_name || dataa.title || dataa.title_pre}
                              </div>
                            </td>
                            <td data-title="Level">
                              <span className="amount">
                                {dataa.level_name || '-'}
                              </span>
                            </td>
                            <td data-title="Duration">
                              <span className="amount">
                                {dataa.duration || dataa.duration_pre || "-"}
                              </span>
                            </td>
                            <td data-title="Size">
                              <span className="amount">
                                {dataa.size || '-'}
                              </span>
                            </td>
                            <td data-title="Color" style={{ textAlign: '-webkit-center' }}>
                              <span className="amount">
                                {dataa.color === null ? '-' : <div style={{ background: dataa.color, height: '35px', width: '35px', borderRadius: '25%' }}></div>}
                              </span>
                            </td>
                            <td data-title="Quantity">
                              {dataa.quantity === null
                                ? '-'
                                : <div className="quantity">
                                  <div onClick={(e) => quantityChange(e, dataa.id, 0, dataa.quantity)} name="minus" className={`quantity-minus qty-btn ${dataa.quantity === 1 ? 'disabled' : ''}`}>
                                    <i className="far fa-minus"></i>
                                  </div>
                                  <input type="number" disabled className="qty-input" value={dataa.quantity} min="1" max="99" />
                                  <div onClick={(e) => quantityChange(e, dataa.id, 1, dataa.quantity)} className='quantity-minus qty-btn'>
                                    <i className="far fa-plus"></i>
                                  </div>
                                </div>
                              }

                            </td>
                            <td data-title="Amount">
                              <span className="amount">
                                {location === "IN"
                                  ? "₹" + (dataa.rupees_pre || dataa.w_rupees || (dataa.rupees * (dataa.quantity || 1)) || (dataa.amount * dataa.quantity))
                                  : "$" + (dataa.doller_pre || dataa.w_doller || (dataa.doller * (dataa.quantity || 1)) || (dataa.amount_dol * dataa.quantity))}
                              </span>
                            </td>
                            <td data-title="Remove">
                              {dataa.subscription_id === 314
                                ? ' '
                                : <Link
                                  onClick={() => handleDelete(dataa.id)}
                                  className="remove"
                                >
                                  <i className="fal fa-trash-alt"></i>
                                </Link>}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </form>

              <div className="row justify-content-space-between">
                <div className="col-md-8 col-lg-7 col-xl-6">
                  {location === "IN"
                    ? <>
                      <h5 className="h5 summary-title">Delivery Address</h5>
                      <p>{data[0].de_address}</p>
                      <Link onClick={() => window.scrollTo({ top: 0, behavior: "instant" })} to={'/editprofile'}><button type="button" className="btn btn-primary btn-xsm" style={{ padding: '5px 10px', fontSize: '11px' }}><i className="fas fa-edit"></i></button></Link>
                    </> : ""}
                </div>
                <div className="col-md-8 col-lg-7 col-xl-6">
                  <h2 className="h4 summary-title">Cart Totals</h2>
                  <table className="cart_totals">
                    <tbody>


                      <tr>
                        <td style={{ textAlign: "initial" }}>Coupon Code</td>
                        <td
                          data-title="Cart Subtotal"
                          style={{ textAlign: "initial" }}
                        >
                          <span className="amount d-flex">
                            <input
                              type="text"
                              name="code"
                              className="form-control"
                              placeholder="Enter Coupon Code"
                              required
                              onChange={handleInputChange}
                            />
                            <button className="btn btn-cancel" onClick={submitCoupon}>Apply</button>
                          </span>
                        </td>
                      </tr>


                      <tr>
                        <td style={{ textAlign: "initial" }}>Cart Subtotal</td>
                        <td
                          data-title="Cart Subtotal"
                          style={{ textAlign: "initial" }}
                        >
                          <span className="amount">
                            {location === "IN"
                              ? "₹" + " " + amount.totalRupees
                              : "$" + amount.totalDoller}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr className="order-total">
                        <td style={{ textAlign: "initial" }}>Order Total</td>
                        <td data-title="Total" style={{ textAlign: "initial" }}>
                          <strong>
                            <span className="amount">
                              {location === "IN"
                                ? "₹" + " " + amount.total_gstrupees
                                : "$" + amount.total_gstdoller}
                            </span>
                          </strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <div className="siderbar-toggle">
                    <label className="switch">
                      <input
                        type="checkbox"
                        name="w_number"
                        onChange={handleOptionChange}
                      />
                      <span className="slider round"></span>
                      <span style={{ paddingLeft: '60px' }}>I agree to the  <Link to={'/terms-&-conditions'} onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}> Terms & conditions</Link> and acknowledge the Privacy Policy
                      </span>
                    </label>
                  </div>
                  <div className="wc-proceed-to-checkout mt-3 mb-30"                  >
                    {location === "IN" ?

                      <>
                        <button type="submit" disabled={teams ? true : false} style={{ width: '100%', opacity: teams ? '.65' : '1' }} className="th-btn mt-2 cashbut" onClick={cashPayment}>
                          <i className="fa-solid fa-money-bill-1"></i> Cash Payment
                        </button>

                      </>
                      : ""}
                    {location === "IN"
                      ? <button className="razorpaybut mt-2" disabled={teams ? true : false} onClick={initiatePayment}>
                        Pay Now
                      </button>
                      : <div className="mt-3" >
                        <PayPalScriptProvider options={initialOptions}>
                          <div>
                            <PayPalButtons
                              disabled={teams ? true : false}
                              createOrder={(dataa, actions) => {
                                const items = data.map(item => {
                                  const dollerValue = item.doller ? Math.round(item.doller) : null;
                                  const wDollerValue = item.w_doller ? Math.round(item.w_doller) : null;
                                  const preRecodValue = item.doller_pre ? Math.round(item.doller_pre) : null;
                                  return {
                                    name: item.table_name || item.w_name || item.title || item.title_pre,
                                    unit_amount: {
                                      currency_code: "USD",
                                      value: dollerValue || wDollerValue || preRecodValue || "0.00" // Default to "0.00" if both are null/undefined
                                    },
                                    quantity: "1"
                                  };
                                });

                                return actions.order.create({
                                  purchase_units: [
                                    {
                                      amount: {
                                        currency_code: "USD",
                                        value: amount.total_gstdoller.toString(), // Ensure this is a string
                                        breakdown: {
                                          item_total: {
                                            currency_code: "USD",
                                            value: amount.total_gstdoller.toString() // Ensure this is a string
                                          }
                                        }
                                      },
                                      items: items
                                    }
                                  ]
                                });
                              }}
                              onApprove={(data, actions) => {
                                return actions.order.capture().then(function (details) {
                                  headleSubmit(null, 1, 'Paypal')
                                  alert("Transaction completed by " + details.payer.name.given_name);
                                });
                              }}
                              onError={(err) => {
                                setError(err);
                                console.error("PayPal Checkout error:", err);
                              }}
                            />
                          </div>
                        </PayPalScriptProvider>
                      </div>}
                    <Link
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "instant" })
                      }
                      to={"/shop"}
                    >
                      <button type="submit" style={{ width: '100%' }} className="th-btn mt-2">
                        Continue Shopping
                      </button>
                    </Link>
                  </div>
                </div>
              </div>

            </>}




          {location === "IN"
            ? <>
              {product.length > 2
                ? <Slider {...settings} className="custom-slider">
                  {product.map((dataa, id) => (
                    <div key={id} className="col-12 my-5">
                      <div className="th-product product-grid mx-2">
                        <div className="product-img pic1">
                          <img
                            src={`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/${dataa.photo}`}
                            alt="Product Image"
                            style={{
                              height: "100%",
                            }}
                            draggable={false}
                            onError={handleimg}
                          />
                          <div className="actions">
                            <Link
                              className="delete-table me-2"
                              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                              to={`/productdetails/${dataa.id}`}
                            >
                              <i className="fa-regular fa-eye"></i>
                            </Link>
                          </div>
                        </div>
                        <div className="product-content">
                          <h3 className="product-title">{dataa.title}</h3>
                          <span className="price">₹ {dataa.amount}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
                : <div className="container">
                  <div className="row">
                    {product.map((dataa, id) => (
                      <div key={id} className="col-6 col-md-3 my-5">
                        <div className="th-product product-grid mx-2">
                          <div className="product-img pic1">
                            <img
                              src={`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/${dataa.photo}`}
                              alt="Product Image"
                              style={{
                                height: "100%",
                              }}
                              draggable={false}
                              onError={handleimg}
                            />
                            <div className="actions">
                              <Link
                                className="delete-table me-2"
                                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                                to={`/productdetails/${dataa.id}`}
                              >
                                <i className="fa-regular fa-eye"></i>
                              </Link>
                            </div>
                          </div>
                          <div className="product-content">
                            <h3 className="product-title">{dataa.title}</h3>
                            <span className="price">₹ {dataa.amount}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>}
            </>
            : ""}
          <Slider {...settings} className="custom-slider">
            {productex.map((dataa, id) => (
              <div className="col-12 my-5" key={id}>
                <div className="th-product product-grid mx-2">
                  <div className="product-img pic1">
                    <img
                      src={`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/${dataa.photo}`}
                      style={{
                        height: "100%",
                      }}
                      draggable={false}
                      onError={handleimg}
                    />

                  </div>
                  <div className="product-content">
                    <h3 className="product-title">{dataa.title}</h3>
                    <span className="price">{location === "IN" ? `₹ ${dataa.amount}` : `$ ${dataa.amount_dol}`}</span>
                    <button type="button" className="btn btn-primary btn-xsm mt-3" onClick={() => { addGroupcart(dataa.id) }} style={{ padding: '5px 10px', fontSize: '11px' }}>Add To Cart</button>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/*           Invoice            */}
        <div className=""
          style={{ position: 'absolute', zIndex: '-30', top: '0', left: '-600px' }}
        >
          <div className="invoice"
            ref={contentRef}
            style={{
              width: '250mm', // Ensure the width matches A4 size
              padding: '20px',
              backgroundColor: '#fff',
              margin: '0 auto',
            }}>
            <div className="invoice-header">
              <div>
                <h1>INVOICE</h1>

              </div>
              <div className="logo">
                <img src="/assets/img/Aerial_Belly_Final_Logo.png" alt="" />
              </div>
            </div>

            <div className="invoice-body">
              <div className="details">
                <div>
                  <strong style={{ fontSize: "20px" }}>AERIALBELLY BY <br /> SHAH NUPUR KAUSHIKKUMAR</strong><br />
                  {/* GSTIN: 24FGRPS1001K1Z9<br /> */}
                  OFFICE NO 518, FIFTH FLOOR, SHILP ZAVERI,<br />
                  SHAYAMAL CROSS ROAD, Ahmedabad<br />
                  Ahmedabad, GUJARAT, 380006<br />
                  Mobile: +91 8487990530<br />
                  Email: aerialbelly@gmail.com

                  <p style={{ marginTop: '15px' }}><b>Invoice No :</b> {invoice}</p>
                  <p style={{ marginTop: '15px' }}><b>Invoice Date :</b> {currentDate}</p>
                </div>
                <div>
                  <strong>Customer Details:</strong><br />
                  {user.name}<br />
                  {/* GSTIN: {user.gst || '-'}<br /> */}
                  Billing Address:<br />
                  {user.de_address || '-'}<br />
                  Mobile: {user.code} {user.phone}<br />
                  Email: {user.email}
                </div>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Item</th>
                    <th>Level</th>
                    <th>Duration</th>
                    <th>Size</th>
                    <th>Color</th>
                    <th>Qty</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((dataa, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{dataa.table_name || dataa.w_name || dataa.title || dataa.title_pre}</td>
                        <td>{dataa.level_name || '-'}</td>
                        <td>{dataa.duration || dataa.duration_pre || '-'}</td>
                        <td> {dataa.size || '-'}</td>
                        <td>{dataa.color === null ? '-' : <div style={{ background: dataa.color, height: '35px', width: '35px', borderRadius: '25%' }}></div>}</td>
                        <td>{dataa.quantity || '-'}</td>
                        <td>
                          {location === "IN"
                            ? "₹" + (dataa.rupees_pre || dataa.w_rupees || (dataa.rupees * (dataa.quantity || 1)) || (dataa.amount * dataa.quantity))
                            : "$" + (dataa.doller_pre || dataa.w_doller || (dataa.doller * (dataa.quantity || 1)))}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>

              <div className="total">
                <div>
                  <div className="counting">
                    <div className="count-text">
                      <p>Discount</p>
                      <p>Amount</p>
                      {/* <p>CGST 9.0%</p>
                      <p>SGST 9.0%</p> */}
                    </div>
                    <div className="count-text">
                      <p>{coupon ? `- ${coupon}%` : '0'}</p>
                      <p>
                        {location === "IN"
                          ? "₹" + " " + amount.totalRupees
                          : "$" + amount.totalDoller}
                      </p>
                      {/* <p>
                        {location === "IN"
                          ? "₹" + " " + (gstamount.gstRupees) / 2
                          : "$" + gstamount.gstDoller}
                      </p>
                      <p>
                        {location === "IN"
                          ? "₹" + " " + (gstamount.gstRupees) / 2
                          : "$" + gstamount.gstDoller}
                      </p> */}
                    </div>
                  </div>
                  <hr />
                  <div className="counting" style={{ justifyContent: 'end' }}>
                    <div className="count-text">
                      <p>Total Amount</p>
                    </div>
                    <div className="count-text">
                      <p>
                        {location === "IN"
                          ? "₹" + " " + amount.total_gstrupees
                          : "$" + amount.total_gstdoller}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="qr-section">
                <div>
                  <b>Bank Details:</b><br />
                  Bank : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Kotak Mahindra
                  Bank<br />
                  Account : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9049207319<br />
                  IFSC Code : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;KKBK0002560<br />
                  Branch : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PRAHLADNAGAR BRANCH<br />
                  Shah Nupur Kaushikkumar
                </div>
                <div style={{ textAlign: 'right' }}>
                  for SHAH NUPUR KAUSHIKKUMAR <br />
                  <img src="/assets/img/sign.png" alt="" />
                  <div className="signature">
                    Authorized Signatory
                  </div>
                </div>
              </div>

            </div>

            <div className="footer">
              <p>Original for Recipient</p>
              <Link to={'https://aerialbelly.com/'} style={{ fontWeight: '500', fontSize: '18px' }}>aerialbelly.com</Link>
            </div>
          </div>
        </div>

      </div >
      <style jsx>{`

          p {
              padding: 0;
              margin: 0;
          }

          .logo img {
              height: 100px;
              margin-top: 30px;
          }
          strong, b {
              font-family: 'Poppins', sans-serif !important;
          }
          .invoice {
              font-family: 'Poppins', sans-serif;
              width: 800px;
              margin: 20px auto;
              padding: 20px;
              border: 1px solid #ddd;
              border-radius: 5px;
              background-color: #ffffff;
          }

          .invoice-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
          }

          .invoice-header h1 {
              font-size: 20px;
              margin: 0;
              color: #0066cc;
          }

          .logo {
              font-weight: bold;
              font-size: 20px;
              color: #006666;
          }

          .invoice-body {
              margin-top: 20px;
          }

          .details {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
          }

          .details div {
              width: 48%;
          }

          table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
          }

          table th,
          table td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
          }

          table th {
              background-color: #f2f2f2;
          }

          .total {
              text-align: right;
              margin-top: 10px;
              font-weight: bold;
              display: flex;
              justify-content: end;
          }

          .counting {
              display: flex;
              text-align: right;
              gap: 80px;
          }

          .footer {
              margin-top: 20px;
              text-align: center;
          }

          .qr-section {
              display: flex;
              justify-content: space-between;
              /* align-items: center; */
              margin-top: 20px;
          }

          .qr-section img {
              width: 150px;
          }

          .signature {
              text-align: right;
          }      

              `}</style>
      <style jsx>{`
        td {
          padding: 8px;
        }
        .shipping-radio {
          height: auto;
          width: auto;
          margin-right: 10px;
        }
        .cashbut i{
        font-size: 18px;
        padding-right: 20px;
        }
        .disabled {
            pointer-events: none;
            opacity: 0.7;
            cursor: not-allowed;
        }

      `}</style>
    </>
  );
}

export default Addtocard;
